{
  "overridesEnabledBadgeLabel": "Überschreibungen an"
}
